import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { BnbaccessBoSharedModule } from '../../shared';

import {
    AutorisationBnbaccessService,
    AutorisationBnbaccessPopupService,
    AutorisationBnbaccessComponent,
    AutorisationBnbaccessDetailComponent,
    AutorisationBnbaccessDialogComponent,
    AutorisationBnbaccessPopupComponent,
    AutorisationBnbaccessDeletePopupComponent,
    AutorisationBnbaccessDeleteDialogComponent,
    autorisationRoute,
    autorisationPopupRoute,
} from './';

let ENTITY_STATES = [
    ...autorisationRoute,
    ...autorisationPopupRoute,
];

@NgModule({
    imports: [
        BnbaccessBoSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        AutorisationBnbaccessComponent,
        AutorisationBnbaccessDetailComponent,
        AutorisationBnbaccessDialogComponent,
        AutorisationBnbaccessDeleteDialogComponent,
        AutorisationBnbaccessPopupComponent,
        AutorisationBnbaccessDeletePopupComponent,
    ],
    entryComponents: [
        AutorisationBnbaccessComponent,
        AutorisationBnbaccessDialogComponent,
        AutorisationBnbaccessPopupComponent,
        AutorisationBnbaccessDeleteDialogComponent,
        AutorisationBnbaccessDeletePopupComponent,
    ],
    providers: [
        AutorisationBnbaccessService,
        AutorisationBnbaccessPopupService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BnbaccessBoAutorisationBnbaccessModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/autorisation/autorisation-bnbaccess.module.ts